import { deviceType } from '@/utils/common'
import blankLayout from '@/views/personalNew/layout/blankLayout.vue'
import MobileReferralsRewards from './mobile/referrals/rewards/index.vue'
import MobileReferralsLayout from './mobile/layout/referralsLayout.vue'
import MobileReferralsLeadsLayout from './mobile/referrals/index.vue'
import MobileReferralsPotential from './mobile/referrals/potential.vue'
import MobileReferralsApplied from './mobile/referrals/appliedPotential.vue'
import MobileReferralsHidden from './mobile/referrals/hiddenPotential.vue'
import MobileReferralsDashboard from './mobile/referrals/dashboard.vue'
import MobileReferralsLeaderBoard from './mobile/referrals/leaderboard.vue'

import PcReferralsRewards from './pc/referrals/rewards/index.vue'
import PcReferralsLeadsLayout from './pc/referrals/leads/index.vue'
import PcReferralsPotential from './pc/referrals/leads/potential.vue'
import PcReferralsApplied from './pc/referrals/leads/appliedPotential.vue'
import PcReferralsHidden from './pc/referrals/leads/hiddenPotential.vue'
import PcReferralsDashboard from './pc/referrals/dashboard/index.vue'
import PcReferralsLeaderBoard from './pc/referrals/leaderboard/index.vue'

const basePath = '/recruiting/personal/referral'

const rewardsRoute = {
  name: 'personalReferralRewards',
  path: `${basePath}/rewards`,
  component: deviceType.isPc ? PcReferralsRewards : MobileReferralsRewards,
  meta: {
    titleI18nKey: 'personal.menu.rewards',
    menuI18nKey: 'personal.menu.mobile.rewards'
  }
}

const leadsRoute = {
  name: 'personalReferralLeads',
  path: `${basePath}/leads`,
  redirect: `${basePath}/leads/potential`,
  component: deviceType.isPc ? PcReferralsLeadsLayout : MobileReferralsLeadsLayout,
  meta: {
    titleI18nKey: 'personal.menu.leads',
    menuI18nKey: 'personal.menu.mobile.leads'
  },
  children: [
    {
      name: 'personalReferralPotentialLeads',
      path: `${basePath}/leads/potential`,
      component: deviceType.isPc ? PcReferralsPotential : MobileReferralsPotential,
      meta: {
        menuI18nKey: 'personal.referrals.leads.menu.potential'
      }
    },
    {
      name: 'personalReferralAppliedLeads',
      path: `${basePath}/leads/applied`,
      component: deviceType.isPc ? PcReferralsApplied : MobileReferralsApplied,
      meta: {
        menuI18nKey: 'personal.referrals.leads.menu.applied'
      }
    },
    {
      name: 'personalReferralHideLeads',
      path: `${basePath}/leads/hidden`,
      component: deviceType.isPc ? PcReferralsHidden : MobileReferralsHidden,
      meta: {
        menuI18nKey: 'personal.referrals.leads.menu.hidden'
      }
    }
  ]
}

const dashboardRoute = {
  name: 'personalReferralDashboard',
  path: `${basePath}/dashboard`,
  component: deviceType.isPc ? PcReferralsDashboard : MobileReferralsDashboard,
  meta: {
    titleI18nKey: 'personal.menu.dashboard',
    menuI18nKey: 'personal.menu.mobile.dashboard'
  }
}

const leaderBoardRoute = {
  name: 'personalReferralLeaderBoard',
  path: `${basePath}/leader-board`,
  component: deviceType.isPc ? PcReferralsLeaderBoard : MobileReferralsLeaderBoard,
  meta: {
    titleI18nKey: 'personal.menu.leaderBoard',
    menuI18nKey: 'personal.menu.mobile.leaderBoard',
    permission: ['COMPUTED_ACCOUNT_IS_EMPLOYEE']
  }
}

export default {
  name: 'personalReferralsIndex',
  path: `${basePath}`,
  component: deviceType.isPc ? blankLayout : MobileReferralsLayout,
  redirect: leadsRoute.path,
  meta: {
    isAllInclude: true,
    menuI18nKey: 'personal.menu.group.referrals',
    mobileHomeMenu: {
      iconClass: 'iconreferrals',
      nameI18nKey: 'personal.referrals.homeMenu.name',
      descI18nKey: 'personal.referrals.homeMenu.desc'
    }
  },
  children: [
    leadsRoute,
    dashboardRoute,
    rewardsRoute,
    leaderBoardRoute
  ]
}

export { rewardsRoute, leadsRoute, leaderBoardRoute, dashboardRoute }
